import { FinanceMessagesDocument, FinanceMessagesQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type Message = FinanceMessagesQuery['finance']['messagesConnection']['nodes'][0]

export const useMessages = (search: string) => {
  const { loading, data, error } = useQuery(FinanceMessagesDocument, {
    variables: {
      search,
    },
  })

  return {
    loading,
    error,
    messages: data?.finance.messagesConnection.nodes,
    totalCount: data?.finance.messagesConnection.totalCount || 0,
  }
}
